export type FileType = 'pdf' | 'jpg' | 'png';

export const fileTypeFromName = (filename: string): FileType | null => {
  const extension = filename.split('.').pop()?.toLowerCase();

  if (extension === 'pdf') return 'pdf';
  if (extension === 'jpg' || extension === 'jpeg') return 'jpg';
  if (extension === 'png') return 'png';

  return null;
};

export const formatFileSize = (bytes: number): string => {
  const sizeInKb = bytes / 1024;
  const sizeInMb = bytes / 1024 ** 2;

  return sizeInMb < 1
    ? `${Math.round(sizeInKb)} KB`
    : `${sizeInMb.toFixed(1)} MB`;
};
